import bhawni from "../../../src/assets/RWOs/Dr Munbhawni Bagga.jpg";
import sohini from "../../../src/assets/RWOs/SOHINI CHAKRABORTY.png";
import { Volume2 } from "lucide-react";
import { YouTube } from "@mui/icons-material";

export const rwoData = [
  {
    name: "DR MUN BHAWNI BAGGA",
    img: bhawni,
    content: (
      <div className="text-[#274760] text-base flex flex-col items-center gap-2 font-semibold">
        <div className="flex items-center gap-2">
          <Volume2 />
          <span>Hear From Me</span>
        </div>
        <div className="flex items-center gap-2">
          <a
            href="https://youtu.be/zp8F3RXMZHI"
            target="_blank"
            rel="noopener noreferrer"
          >
            <YouTube className="text-red-500" />
            <span>English</span>
          </a>
          <a
            href="https://youtu.be/zcCUORbCuvU"
            target="_blank"
            rel="noopener noreferrer"
          >
            <YouTube className="text-red-500" />
            <span>Hindi</span>
          </a>
        </div>
      </div>
    ),
  },
  {
    name: "DR SOHINI CHAKRABORTY",
    img: sohini,
    content: (
      <div className="text-[#274760] text-base flex flex-col items-center gap-2 font-semibold">
        <div className="flex items-center gap-2">
          <Volume2 />
          <span>Hear From Me</span>
        </div>
        <div className="flex items-center gap-2">
          <a
            href="https://youtu.be/t9Xd6DgwDzM"
            target="_blank"
            rel="noopener noreferrer"
          >
            <YouTube className="text-red-500" />
            <span>English</span>
          </a>
          <a
            href="https://youtu.be/VLU8YYJxD80"
            target="_blank"
            rel="noopener noreferrer"
          >
            <YouTube className="text-red-500" />
            <span>Assamese</span>
          </a>
        </div>
      </div>
    ),
  },
];
